export const HIDE_NAV_PARAM = "hideNavigation";

export function isNavigationOff() {
  const urlParams = new URLSearchParams(window.location.search);
  const isHideNavigationViaQueryParam = urlParams.get(HIDE_NAV_PARAM);

  if (isHideNavigationViaQueryParam) {
    sessionStorage.setItem(HIDE_NAV_PARAM, "true");
  }

  if (isHideNavigationViaQueryParam || sessionStorage.getItem(HIDE_NAV_PARAM)) {
    return true;
  }

  return false;
}
